<template>
  <v-app>
    <Navbar/>
    <div>
      <v-content>
        <v-container grid-list-lg>
          <v-layout row wrap>
            <v-flex lg5>
              <v-card>
                <v-card-title><h4>Asiakasinfo</h4></v-card-title>
                <v-divider></v-divider>
                <v-list dense class="pukulist">
                  <v-list-tile>
                    <v-list-tile-content><b>Nimi:</b></v-list-tile-content>
                    <v-list-tile-content class="align-end">{{this.customer.name}}</v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-content><b>Sähköposti:</b></v-list-tile-content>
                    <v-list-tile-content class="align-end">{{this.customer.email}}</v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-content><b>Puhelinnumero:</b></v-list-tile-content>
                    <v-list-tile-content class="align-end">{{this.customer.phone}}</v-list-tile-content>
                  </v-list-tile>              
                  <v-list-tile>
                    <v-list-tile-content><b>Maa:</b></v-list-tile-content>
                    <v-list-tile-content class="align-end">{{this.customer.country}}</v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-content><b>Kaupunki:</b></v-list-tile-content>
                    <v-list-tile-content class="align-end">{{this.customer.city}}</v-list-tile-content>
                  </v-list-tile> 
                  <v-list-tile>
                    <v-list-tile-content><b>Osoite:</b></v-list-tile-content>
                    <v-list-tile-content class="align-end">{{this.customer.address}}</v-list-tile-content>
                  </v-list-tile>  
                     <v-list-tile>
                    <v-list-tile-content><b>Y-tunnus:</b></v-list-tile-content>
                    <v-list-tile-content class="align-end">{{this.customer.business_id}}</v-list-tile-content>
                  </v-list-tile>  
                     <v-list-tile>
                    <v-list-tile-content><b>Postinumero:</b></v-list-tile-content>
                    <v-list-tile-content class="align-end">{{this.customer.postalcode}}</v-list-tile-content>
                  </v-list-tile>
                   <v-list-tile>
                      <v-list-tile-content><b>Hyväksy tila:</b></v-list-tile-content>
                      <v-list-tile-content class="align-end">{{this.customer.status}}</v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile>
                      <v-list-tile-content><b>Rooli:</b></v-list-tile-content>
                      <v-list-tile-content class="align-end">{{this.customer.role}}</v-list-tile-content>
                    </v-list-tile>                     
                </v-list>
                 <v-divider></v-divider>
                  <v-flex  class="order_action justify-center py-4" > 
                  
                    <v-btn @click="ApproveUser()"  small color="success" dark>Hyväksy</v-btn>
                    <v-btn @click="RejectUser()" small color="error" dark>Hylkää</v-btn>
                      <v-btn  @click="ResetPassword()" small color="black" dark>Nollaa salasana</v-btn>
                  </v-flex>
                             <v-divider></v-divider>
                               <v-flex  class="order_action justify-center py-4" > 
                              
                      <v-btn  @click="DeliveryUser()" small color="primary" dark>Toimituskäyttäjä</v-btn>
                      <v-btn  @click="AdminUser()" small color="orange" dark>Adminkäyttäjä</v-btn>
                                   <v-btn  @click="RegisteredUser()" small color="blue" dark>Asiakkaat</v-btn>
                       <v-btn  @click="ApproveTehden()" small color="red" dark>Tehden Hyväksyä</v-btn>
                   
</v-flex>
 
                             <!-- <v-divider></v-divider>
                                <v-flex  class="order_action justify-center py-4" > 
                         <v-btn  @click="ApproveTehden()" small color="red" dark>Tehden Onay</v-btn>
                    </v-flex> -->
              </v-card>
            </v-flex>         
            <v-flex lg7>
              <v-card>
                <v-card-title><h4>Tilaushistoria</h4></v-card-title>             
                <v-divider></v-divider>
                <v-data-table
                  :headers="headers"
                  :items="customers"
                  :search="search"
                  :rows-per-page-items="rowsPerPageItems"
                  :pagination.sync="pagination"
                  row
                  wrap
                  class="elevation-1 mx-3">
                  <template slot="items" slot-scope="props">                            
                    <!-- <td class="text-xs-left">#{{ props.item.id }}</td> -->
                      <td class="text-xs-left order_id"><router-link :to="{ name: 'ViewOrder', params: {id:props.item.id} }">#{{ props.item.id }}</router-link></td>
                    <td class="text-xs-left">{{ props.item.timestamp }}</td>
                    <td class="text-xs-left">{{ props.item.quantity }}</td>
                    <td class="text-xs-left">{{currency}}{{ props.item.checkout_total }}</td>
                    <td class="text-xs-left">{{ props.item.order_status }}</td>
                  </template>
                </v-data-table>
              </v-card>
            </v-flex>
              <div class="text-center"> 
              <v-snackbar
                v-model="usetehdenSnackbar"
                :timeout="timeout"
              >              
                {{ usetehdenText }}
                <v-btn
                  color="blue"
                  text
                  @click="snackbar = false"
                >
                  Close
                </v-btn>
              </v-snackbar>
            </div>
             <div class="text-center"> 
              <v-snackbar
                v-model="useapproveSnackbar"
                :timeout="timeout"
              >              
                {{ useapproveText }}
                <v-btn
                  color="blue"
                  text
                  @click="snackbar = false"
                >
                  Close
                </v-btn>
              </v-snackbar>
            </div>
             <div class="text-center"> 
              <v-snackbar
                v-model="alreadyApprovedSnackbar"
                :timeout="timeout"
              >              
                {{ alreadyApprovedText }}
                <v-btn
                  color="red"
                  text
                  @click="snackbar = false"
                >
                  Close
                </v-btn>
              </v-snackbar>
            </div>
            <div class="text-center"> 
              <v-snackbar
                v-model="userapprovedSnackbar"
                :timeout="timeout"
              >              
                {{ userapprovedText }}
                <v-btn
                  color="green"
                  text
                  @click="snackbar = false"
                >
                  Close
                </v-btn>
              </v-snackbar>
            </div>
              <div class="text-center"> 
              <v-snackbar
                v-model="userapprovingSnackbar"
                :timeout="timeout"
              >              
                {{ userapprovingText }}
                <v-btn
                  color="green"
                  text
                  @click="snackbar = false"
                >
                  Close
                </v-btn>
              </v-snackbar>
            </div>
            
          </v-layout>
        </v-container>
      </v-content>
    </div>
  </v-app>
</template>

<script>
  import Navbar from '@/components/admin/navbar/Navbar'
  import db from '@/firebase/init'
  import moment from 'moment'
  import firebase from "firebase";
    import axios from "axios";
  export default {
    name:'ViewCustomer',
    components: {
      Navbar
    },
    data(){
      return{
        rowsPerPageItems: [8, 16, 24],
        pagination: {
        rowsPerPage: 8
        },
        customer:[],        
        name:null,
        email:null,
        phone:null,
        country:null,
        city:null,         
        address:null,         
        feedback:null, 
        currency:'',
         timeout: 3000,
        userapprovedSnackbar: false,
        userapprovingSnackbar: false,
        useapproveSnackbar: false,
        usetehdenSnackbar: false,
        alreadyApprovedSnackbar:false,
        userapprovingText:'käsittelee...',
        userapprovedText:'käyttäjä hyväksytty',
        alreadyApprovedText:'tämä käyttäjä on jo hyväksytty',
        useapproveText: 'käytä hyväksymispainiketta',
        usetehdenText: 'käyttäjä, käytä Tehden hyväksymispainiketta',
        customerSalesRecords:[],
        headers: [                
          { text: 'tilausnumero' , value: 'id', sortable: !1 },  
          { text: 'tilauspäivämäärä' , value: 'created', sortable: !1 },  
          { text: 'Esineiden määrä' , value: 'quantity', sortable: !1 },
          { text: 'kokonaishinta' , value: 'checkout_total', sortable: !1 },
          { text: 'tilauksen tila' , value: 'order_status', sortable: !1 },                                         
        ],
        customers:[],
        search:'',    
      }
    },  
    methods:{    
       ResetPassword(){       

                let res =  axios.get("https://europe-west1-elatukku-23ef3.cloudfunctions.net/ResetPassword?uid="+this.$route.params.id).
                then(res=> {
                  console.log(res.data)
                })
                  .catch(error => { console.log(error); });
                  
                //      let resx =  axios.get("https://europe-west1-elatukku-23ef3.cloudfunctions.net/sendApproveMail?dest="+this.customer.id).
                // then(res=> {
                //   console.log(res.data)
                // })
                //   .catch(error => { console.log(error); });
              
      },  
       ApproveTehden(){       

 var db = firebase.firestore(); 
              let userRef = db.collection('profiles').doc(this.$route.params.id);

    userRef.get().then(doc=>{

 console.log("asdasda: " +doc)

       if(doc.data().isapproved==true)
      {
       
       this.alreadyApprovedSnackbar=true;
      return;
      }

      // if(doc.data().customer_id=="")
      // {
      //   this.useapproveSnackbar=true;
      // return;
      // }
     
                let res =  axios.get("https://europe-west1-elatukku-23ef3.cloudfunctions.net/ApproveTehdenUser?uid="+this.$route.params.id).
              //  let res =  axios.get("http://localhost:5001/elatukku-23ef3/europe-west1/ApproveTehdenUser?uid="+this.$route.params.id).
                then(res=> {
                  console.log(res)
                  if(res.status==400)
                  this.useapproveSnackbar=true;
                })
                  .catch(error => { 
                    this.useapproveSnackbar=true;
                    console.log(error); 
                    });
                       });
                               
              
      },   
           ApproveUser(){    

              var db = firebase.firestore(); 
              let userRef = db.collection('profiles').doc(this.$route.params.id);

    userRef.get().then(doc=>{
 //console.log("asdasda: " +doc.data().customer_id)

       if(doc.data().isapproved==true)
      {
       this.alreadyApprovedSnackbar=true;
      return;
      }
      if(doc.data().customer_id!="")
      {
        this.usetehdenSnackbar=true;
      return;
      }
     
 this.userapprovingSnackbar=true;

                let res =  axios.get("https://europe-west1-elatukku-23ef3.cloudfunctions.net/approveuser?uid="+this.$route.params.id).
                then(res=> {
                  console.log(res.data)
                   if(res.status==400)
                    this.usetehdenSnackbar=true;

                    if(res.status==403)
                    this.alreadyApprovedSnackbar=true;
                })
                  .catch(error => { 
                    if(res.status==400)
                    this.usetehdenSnackbar=true;

                    if(res.status==403)
                    this.alreadyApprovedSnackbar=true;

                    console.log(error);                     
                    });
                  
                     let resx =  axios.get("https://europe-west1-elatukku-23ef3.cloudfunctions.net/sendApproveMail?dest="+this.customer.id).
                then(res=> {
                  console.log(res.data)
                })
                  .catch(error => { console.log(error); });

                     })
              
      },
        RejectUser(){       

                let userRef = db.collection('profiles').doc(this.$route.params.id);
          userRef.update({            
            role:'Customer',
            isapproved:false,
            status:'Reddedildi'          
        })

        let deliveryRef= db.collection('delivery_person').doc(this.$route.params.id).delete();     

      },
        DeliveryUser(){                   

        let userRef = db.collection('profiles').doc(this.$route.params.id);
          userRef.update({            
            role:"Delivery"          
        })

        let deliveryRef=db.collection('delivery_person').doc(this.$route.params.id);
        deliveryRef.set({
          id:this.$route.params.id,
          name:this.customer.firstname + ' '+this.customer.lastname,
          email:this.customer.email,
          phone:this.customer.phone,
          ptoken:this.customer.ptoken,          
           role:"Delivery",
          timestamp:Date.now()
        })

      },
      RegisteredUser(){                   

        let userRef = db.collection('profiles').doc(this.$route.params.id);
          userRef.update({            
            role:"Customer"          
        })

        let deliveryRef=db.collection('delivery_person').doc(this.$route.params.id);
        deliveryRef.delete()
      },
        AdminUser(){       

              let userRef = db.collection('profiles').doc(this.$route.params.id);
          userRef.update({            
            role:"Admin"          
        })
        let deliveryRef=db.collection('delivery_person').doc(this.$route.params.id);
        deliveryRef.set({
          id:this.$route.params.id,
          name:this.customer.firstname + ' '+this.customer.lastname ,
          email:this.customer.email,
          phone:this.customer.phone,
           ptoken:this.customer.ptoken,  
          role:"Admin",
          timestamp:Date.now()          
        })
      }   
    },
    created(){
      // Current Currency
      db.collection("settings").doc('config').onSnapshot(doc =>{
        this.currency = doc.data().currency
      })

      // Single Customer
      db.collection("profiles").doc(this.$route.params.id).onSnapshot(doc =>{
        this.customer = doc.data()
        this.customer.id = doc.id

        if(doc.data().status=='Bekleniyor')
        this.customer.status='Odottaa'
          if(doc.data().status=='Onaylandı')
        this.customer.status='Hyväksytty'
             if(doc.data().status=='Reddedildi')
        this.customer.status='Peruutettu'
        
      })
  
      // Customer Purchase Records
      let ref = db.collection('orders').where("user_id","==",this.$route.params.id).orderBy('timestamp', 'desc')

      ref.onSnapshot(snapshot => {
        snapshot.docChanges().forEach(change => {
        if(change.type == 'added'){
            let doc = change.doc
            this.customers.push({
                id:doc.id,                    
                timestamp:doc.data().date + " " +doc.data().time,      
                quantity:doc.data().quantity,               
                order_status:doc.data().order_status,               
                checkout_total:doc.data().checkout_total,               
            })
        }
        })
      })
    }

  }
</script>

<style>
tbody a{
  font-size: 13px;
  color:black;
  text-decoration: underline;
}
.primary--text {
  color: #345B2C !important;
  caret-color: #345B2C !important;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/customers/ViewCustomer.vue